import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { AudioCallService } from '../service/audio-call.service';
import { Location } from '@angular/common';

@Component({
  selector: 'ngx-audio-call-consult',
  templateUrl: './audio-call-consult.component.html',
  styleUrls: ['./audio-call-consult.component.scss']
})
export class AudioCallConsultComponent implements OnInit, OnDestroy {

  @ViewChild('remoteAudio') remoteAudio: ElementRef<HTMLAudioElement>;

  roomId = 'room-voice-123';   // static for now
  callStatus = 'idle';
  isMuted = false;

  constructor(
    public call: AudioCallService,
    private location: Location
  ) {}

  ngOnInit() {
    this.call.callStatus$?.subscribe?.(s => this.callStatus = s);

    this.call.remoteStream$.subscribe(stream => {
      if (stream && this.remoteAudio) {
        this.remoteAudio.nativeElement.srcObject = stream;
        this.remoteAudio.nativeElement.muted = false;
        this.remoteAudio.nativeElement.play().catch(() => {});
      }
    });

    setTimeout(() => this.call.createOrJoinRoom(this.roomId), 500);
  }

  ngOnDestroy() {
    this.call.endCall();
  }

  hangup() {
    this.call.endCall();
    this.location.back();
  }

  mute() {
    this.isMuted = !this.isMuted;
    this.call.toggleMic();
  }
}
